import { useState, useCallback, useEffect } from "react";
import { useActivation } from "./ActivationContext";
import {
  getTourActionHint,
  isManualTourSubstep,
} from "./activationPath";
import { validateTourSubstep } from "./tourValidation";
import s from "./activation.module.css";

/**
 * Calm in-sheet guidance when a form / dialog is open.
 * Replaces the floating callout so hints don't fight the modal.
 */
export default function ActivationSheetHint({ stepIds }) {
  const {
    tourActive,
    walkthroughReplay,
    currentStep,
    currentSubstep,
    currentSubstepId,
    progressCount,
    totalSteps,
    advanceSubstep,
  } = useActivation();

  const ids = (Array.isArray(stepIds) ? stepIds : [stepIds]).filter(Boolean);

  const matches =
    tourActive &&
    currentStep &&
    ids.includes(currentStep.id) &&
    currentSubstep &&
    currentSubstep.kind !== "nav";

  const manualAdvance = isManualTourSubstep(currentSubstepId);
  const [advanceBlock, setAdvanceBlock] = useState("");

  useEffect(() => {
    setAdvanceBlock("");
  }, [currentSubstepId]);

  const handleAdvance = useCallback(() => {
    if (!currentStep?.id || !currentSubstepId) return;
    if (!walkthroughReplay) {
      const check = validateTourSubstep(currentStep.id, currentSubstepId);
      if (!check.ok) {
        setAdvanceBlock(check.message || "Заполните поле, чтобы продолжить");
        return;
      }
    }
    setAdvanceBlock("");
    advanceSubstep();
  }, [advanceSubstep, currentStep?.id, currentSubstepId, walkthroughReplay]);

  if (!matches) return null;

  const actionHint = !manualAdvance
    ? getTourActionHint(currentSubstepId)
    : "";

  return (
    <div className={s.actSheetHint} role="status" aria-live="polite">
      <span className={s.actSheetHintBadge}>
        {Math.min(progressCount + 1, totalSteps)}/{totalSteps}
      </span>
      <div className={s.actSheetHintBody}>
        <strong>{currentSubstep.title}</strong>
        <span>{currentSubstep.hint}</span>
        {actionHint ? (
          <span className={s.actSheetHintAction}>{actionHint}</span>
        ) : null}
        {advanceBlock ? (
          <span className={s.actSheetHintWarn} role="alert">
            {advanceBlock}
          </span>
        ) : null}
      </div>
      {manualAdvance ? (
        <button
          type="button"
          className={s.actSheetHintBtn}
          onClick={handleAdvance}
        >
          Далее
        </button>
      ) : null}
    </div>
  );
}
